import React, { useState, useEffect } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import Moment from "react-moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import image from "../../../Assets/image.png";
import ReturnModal from "./ordersReturnModal";

import CancelModel from "./cancelOrder";
function Products() {
    const Navigate = useNavigate();
    const [params] = useSearchParams();
    const [returnMododal, setReturnModal] = useState(false);
    const [cancelModel, setcancelmodel] = useState(false);
    let [loading, setLoading] = useState(true);
    const [disable, setDisable] = useState(false);
    const [status, setStatus] = useState();
    const [orders, setOrders] = useState([]);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };

    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    const getorders = () => {
        Services.OrdersInfo("GET", null, token, params.get("id"))
            .then((res) => {
                console.log(res);
                setLoading(false);
                if (res.Status === 1) {
                    setOrders(res.orders);
                    // setOrdersSearch(res.Orders);
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        getorders();

        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (status) {
            statusHandler();
        }
    }, [status]);
    const dateformatter = (cell) => {
        const date = new Date(cell);

        return (
            <p>
                <Moment format="MMMM Do YYYY hh:mm a">{date}</Moment>
            </p>
        );
    };

    const orderstatusformatter = (cell, cellcontent) => {
        //eslint-disable-next-line
        if (cell == "Delivered") {
            return (
                <div
                    style={{
                        display: "grid",
                        alignItems: "center",
                        justifyItems: "center",
                        justifySelf: "right",
                        gap: "0.5rem",
                    }}>
                    <div
                        className={`${
                            dashboardclasses[`order-delivered-wrapper`]
                        } ${dashboardclasses[`order-status-wrapper`]}`}>
                        <p className={dashboardclasses["order-delivered"]}>
                            Delivered
                        </p>
                    </div>
                </div>
            );
        }
        if (cell == "Payment-Success") {
            return (
                <div
                    style={{
                        display: "grid",
                        alignItems: "center",
                        justifyItems: "center",
                        justifySelf: "right",
                        gap: "0.5rem",
                    }}>
                    <div
                        className={`${
                            dashboardclasses[`order-delivered-wrapper`]
                        } ${dashboardclasses[`order-status-wrapper`]}`}>
                        <p className={dashboardclasses["order-delivered"]}>
                            Payment-Success
                        </p>
                    </div>
                </div>
            );
        }

        if (cell == "AdminCanceled" || cell == "UserCanceled") {
            return (
                <div
                    className={`${dashboardclasses[`order-returned-wrapper`]} ${
                        dashboardclasses[`order-status-wrapper`]
                    }`}>
                    <p>Cancelled</p>
                </div>
            );
        }
        //eslint-disable-next-line
        if (cell == "Payment-Failed") {
            return (
                <div className={dashboardclasses[`cancel-wrapper`]}>
                    <p className={dashboardclasses["cancel"]}>
                        Payment-Failed{" "}
                    </p>
                </div>
            );
        } else {
            return (
                <div
                    className={`${dashboardclasses[`order-pending-wrapper`]} ${
                        dashboardclasses[`order-status-wrapper`]
                    }`}>
                    <p>{cell}</p>
                </div>
            );
        }
    };
    const statuschangehandler = (e) => {
        setStatus(e.target.value);
    };
    const statusHandler = (e) => {
        setLoading(true);
        let body = {
            status: status,
            userId: orders.userId,
            mobile: orders.mobile,
            type: "omni",
        };
        Services.updateOrderStatus(
            "POST",
            JSON.stringify(body),
            token,
            params.get("id")
        )
            .then((res) => {
                if (res.Status === 1) {
                    getorders();
                    toast.success(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    // setOrdersSearch(res.Orders);
                } else if (res.Status === 0) {
                    setLoading(false);
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const pickuphandler = () => {
        setDisable(true);
        let body = { status: "Payment Success", orderid: orders.orderid };
        Services.packorder(
            "POST",
            JSON.stringify(body),
            token,
            params.get("id")
        )
            .then((res) => {
                setDisable(false);
                if (res.Status === 1) {
                    getorders();
                    toast.success(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    // setOrdersSearch(res.Orders);
                } else if (res.Status === 0) {
                    setLoading(false);
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                setDisable(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    return (
        <>
            {cancelModel && (
                <CancelModel
                    setmodal={setcancelmodel}
                    id={params.get("id")}
                    getorders={getorders}
                    setLoading={setLoading}
                />
            )}
            {returnMododal && (
                <ReturnModal
                    setmodal={setReturnModal}
                    orders={orders}
                    getorders={getorders}
                />
            )}

            <Layout Active={"GroceryOrders"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <button
                                    className={dashboardclasses["backbutton"]}
                                    onClick={() => {
                                        Navigate(-1);
                                    }}>
                                    Back
                                </button>
                                <header
                                    className={
                                        dashboardclasses["order-details-header"]
                                    }>
                                    <h3>Order Details</h3>
                                    <div
                                        className={
                                            dashboardclasses[
                                                "order-header-item"
                                            ]
                                        }>
                                        <h5>ORDER ID</h5>

                                        <p>#{orders.orderid}</p>
                                    </div>
                                    <div
                                        className={
                                            dashboardclasses[
                                                "order-header-item"
                                            ]
                                        }>
                                        <h5>ORDER DATE TIME</h5>

                                        {dateformatter(orders.created)}
                                    </div>
                                </header>
                                <div
                                    className={
                                        dashboardclasses[
                                            "orders-form-invoice-wrapper"
                                        ]
                                    }>
                                    <div
                                        className={
                                            dashboardclasses[
                                                "orders-form-invoice"
                                            ]
                                        }>
                                        <div
                                            className={
                                                dashboardclasses[
                                                    "invoice-detail"
                                                ]
                                            }>
                                            <div
                                                className={
                                                    dashboardclasses[
                                                        "detail-status"
                                                    ]
                                                }>
                                                <span>Status:</span>
                                                {orders?.status !=
                                                    "AdminCanceled" &&
                                                orders?.status !=
                                                    "UserCanceled" &&
                                                orders?.status != "Delivered" &&
                                                orders.status !=
                                                    "Payment-Failed" ? (
                                                    <select
                                                        defaultValue={
                                                            orders.orderStatus
                                                        }
                                                        onChange={
                                                            statuschangehandler
                                                        }>
                                                        {" "}
                                                        <option
                                                            value=""
                                                            default>
                                                            Update status
                                                        </option>
                                                        {/* <option value="Accepted">
                                                            Accepted
                                                        </option> */}
                                                        <option value="Delivered">
                                                            Delivered{" "}
                                                        </option>
                                                        <option value="AdminCanceled">
                                                            Admin Cancel{" "}
                                                        </option>
                                                    </select>
                                                ) : (
                                                    orderstatusformatter(
                                                        orders.status
                                                    )
                                                )}
                                            </div>
                                            <div
                                                className={
                                                    dashboardclasses[
                                                        "order-handler"
                                                    ]
                                                }>
                                                {
                                                    <button
                                                        className={
                                                            dashboardclasses[
                                                                "pack-order"
                                                            ]
                                                        }
                                                        disabled={
                                                            disable ||
                                                            orders.IsPacked == 1
                                                        }
                                                        onClick={pickuphandler}>
                                                        {" "}
                                                        {orders.IsPacked == 1
                                                            ? "Packed"
                                                            : "Pickup Order"}
                                                    </button>
                                                }
                                            </div>
                                        </div>

                                        <div
                                            className={
                                                dashboardclasses["order-items"]
                                            }>
                                            <header
                                                className={
                                                    dashboardclasses[
                                                        "customer-info-header"
                                                    ]
                                                }>
                                                <h4>Customer Info</h4>
                                            </header>

                                            <div>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-item-data"
                                                        ]
                                                    }>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Name</h5>
                                                        <h4>:</h4>
                                                        <p>{orders.username}</p>
                                                    </div>

                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Contact Number</h5>
                                                        <h4>:</h4>
                                                        <p>{orders.mobile}</p>
                                                    </div>
                                                    {/* <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>shop</h5>
                                                        <h4>:</h4>
                                                        <p> {orders.shop}</p>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div
                                                className={
                                                    dashboardclasses[
                                                        "order-item-data"
                                                    ]
                                                }
                                                style={{ gap: "1rem" }}>
                                                <h4> Order List</h4>
                                                {orders?.cartitems?.map(
                                                    (items) => (
                                                        <div
                                                            className={
                                                                dashboardclasses[
                                                                    "order-item"
                                                                ]
                                                            }>
                                                            <img
                                                                src={
                                                                    items?.image !==
                                                                    "NA"
                                                                        ? items.image
                                                                        : image
                                                                }
                                                                alt="product"
                                                                onError={({
                                                                    currentTarget,
                                                                }) => {
                                                                    currentTarget.onerror =
                                                                        null; // prevents looping
                                                                    currentTarget.src =
                                                                        image;
                                                                }}
                                                            />
                                                            <div
                                                                className={
                                                                    dashboardclasses[
                                                                        "order-desc"
                                                                    ]
                                                                }>
                                                                <h3>
                                                                    {
                                                                        items?.name
                                                                    }
                                                                </h3>
                                                                <p>
                                                                    Quantity:
                                                                    {
                                                                        items?.quantity
                                                                    }
                                                                </p>
                                                                <p>
                                                                    variant:
                                                                    {items?.qty}
                                                                </p>
                                                                <p>
                                                                    Brand:{" "}
                                                                    {
                                                                        items.brand
                                                                    }
                                                                </p>
                                                                <h3>
                                                                    Price:₹
                                                                    {Math.round(
                                                                        items.dmrp
                                                                    )}
                                                                    <span>
                                                                        (Inclusive
                                                                        of all
                                                                        taxes)
                                                                    </span>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            <div
                                                className={
                                                    dashboardclasses[
                                                        "order-item-data"
                                                    ]
                                                }>
                                                <h4>Vendor Info</h4>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>Name</h5>
                                                    <h4>:</h4>
                                                    <p>
                                                        {orders.vendorinfo.name}
                                                    </p>
                                                </div>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>mobile</h5>
                                                    <h4>:</h4>
                                                    <p>
                                                        {
                                                            orders.vendorinfo
                                                                .mobile
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className={
                                                    dashboardclasses[
                                                        "order-item-data"
                                                    ]
                                                }>
                                                <h4>Shipping Details </h4>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date-address"
                                                        ]
                                                    }>
                                                    <h5>Address</h5>
                                                    <h4>:</h4>
                                                    <p>{orders?.address}</p>
                                                </div>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date-address"
                                                        ]
                                                    }>
                                                    <h5>longlat</h5>
                                                    <h4>:</h4>
                                                    <p>{orders?.longlat}</p>
                                                </div>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date-address"
                                                        ]
                                                    }>
                                                    <h5>Book Date and Time</h5>
                                                    <h4>:</h4>
                                                    <p>
                                                        {orders?.bookdate}{" "}
                                                        {orders?.booktime}
                                                    </p>
                                                </div>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>Invoice</h5>
                                                    <h4>:</h4>
                                                    <p>
                                                        {orders?.invoicefile ? (
                                                            <button
                                                                style={{
                                                                    border: "none",
                                                                    textDecoration:
                                                                        "underLine",
                                                                    color: "red",
                                                                    backgroundColor:
                                                                        "inherit",
                                                                }}
                                                                onClick={() => {
                                                                    window.open(
                                                                        orders?.invoicefile,
                                                                        "_blank"
                                                                    );
                                                                }}>
                                                                Invoice
                                                            </button>
                                                        ) : (
                                                            "NA"
                                                        )}
                                                    </p>
                                                </div>
                                                {orders?.DeliveredDatetime && (
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date-address"
                                                            ]
                                                        }>
                                                        <h5>
                                                            Delivery Date Time
                                                        </h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {
                                                                orders?.DeliveredDatetime
                                                            }
                                                        </p>
                                                    </div>
                                                )}
                                            </div>

                                            <div
                                                className={
                                                    dashboardclasses[
                                                        "order-item-data"
                                                    ]
                                                }>
                                                <h4> Payment Details </h4>

                                                {orders.paymentType === 2 && (
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>PaymentID</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {
                                                                orders.transactionId
                                                            }
                                                        </p>
                                                    </div>
                                                )}
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>SubTotal</h5>
                                                    <h4>:</h4>
                                                    <p> ₹ {orders.subTotal}</p>
                                                </div>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>Discount Amount</h5>
                                                    <h4>:</h4>
                                                    <p>₹ {orders?.discount}</p>
                                                </div>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>Wallet Amount Used</h5>
                                                    <h4>:</h4>
                                                    <p>
                                                        ₹ {orders?.walletAmount}
                                                    </p>
                                                </div>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>Coupon</h5>
                                                    <h4>:</h4>
                                                    <p>{orders?.couponcode}</p>
                                                </div>

                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>Shipping Charges</h5>
                                                    <h4>:</h4>
                                                    <p> ₹ {orders?.shipping}</p>
                                                </div>

                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>Tip</h5>
                                                    <h4>:</h4>
                                                    <p> ₹ {orders?.tip}</p>
                                                </div>

                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-date"
                                                        ]
                                                    }>
                                                    <h5>Grand Total</h5>
                                                    <h4>:</h4>

                                                    <p>
                                                        ₹ {orders?.orderTotal}
                                                    </p>
                                                </div>
                                            </div>
                                            {/*  {params.get("order-type") != 1 && (
                                                <button
                                                    style={{
                                                        justifySelf: "center",
                                                        height: "2.5rem",
                                                        width: "8rem",
                                                        fontSize: "1rem",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        backgroundColor: "red",
                                                        color: "white",
                                                    }}
                                                    // onClick={() => {
                                                    //     setcancelmodel(true);
                                                    // }}
                                                >
                                                    Cancel Order
                                                </button>
                                            )} */}
                                            {/* <div className="category-table">
                                            <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            data={orders.orderitems}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            pagination={pagination}
                                                wrapperClasses="table-responsive"
                                                />
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Products;
